export const protectedPersonRoles = ["appl_pp", "prp_18", "prp_14"];
export const unProtectedPersonRoles = ["appl", "pg", "pwc", "gpgo_o18", "resp"];